import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const NYSCInfoStep = ({ formData, errors, onChange }) => {
  const batchOptions = [
    { value: '2024-batch-a', label: '2024 Batch A' },
    { value: '2024-batch-b', label: '2024 Batch B' },
    { value: '2024-batch-c', label: '2024 Batch C' },
    { value: '2025-batch-a', label: '2025 Batch A' },
    { value: '2025-batch-b', label: '2025 Batch B' }
  ];

  const stateOfDeploymentOptions = [
    { value: 'abia', label: 'Abia' },
    { value: 'adamawa', label: 'Adamawa' },
    { value: 'akwa-ibom', label: 'Akwa Ibom' },
    { value: 'anambra', label: 'Anambra' },
    { value: 'bauchi', label: 'Bauchi' },
    { value: 'bayelsa', label: 'Bayelsa' },
    { value: 'benue', label: 'Benue' },
    { value: 'borno', label: 'Borno' },
    { value: 'cross-river', label: 'Cross River' },
    { value: 'delta', label: 'Delta' },
    { value: 'ebonyi', label: 'Ebonyi' },
    { value: 'edo', label: 'Edo' },
    { value: 'ekiti', label: 'Ekiti' },
    { value: 'enugu', label: 'Enugu' },
    { value: 'fct', label: 'Federal Capital Territory' },
    { value: 'gombe', label: 'Gombe' },
    { value: 'imo', label: 'Imo' },
    { value: 'jigawa', label: 'Jigawa' },
    { value: 'kaduna', label: 'Kaduna' },
    { value: 'kano', label: 'Kano' },
    { value: 'katsina', label: 'Katsina' },
    { value: 'kebbi', label: 'Kebbi' },
    { value: 'kogi', label: 'Kogi' },
    { value: 'kwara', label: 'Kwara' },
    { value: 'lagos', label: 'Lagos' },
    { value: 'nasarawa', label: 'Nasarawa' },
    { value: 'niger', label: 'Niger' },
    { value: 'ogun', label: 'Ogun' },
    { value: 'ondo', label: 'Ondo' },
    { value: 'osun', label: 'Osun' },
    { value: 'oyo', label: 'Oyo' },
    { value: 'plateau', label: 'Plateau' },
    { value: 'rivers', label: 'Rivers' },
    { value: 'sokoto', label: 'Sokoto' },
    { value: 'taraba', label: 'Taraba' },
    { value: 'yobe', label: 'Yobe' },
    { value: 'zamfara', label: 'Zamfara' }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-amber-500 rounded-full flex items-center justify-center flex-shrink-0">
            <span className="text-white text-lg">🎖️</span>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-1">NYSC Information</h3>
            <p className="text-sm text-gray-600">
              Provide your National Youth Service Corps details and deployment information.
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="NYSC Call-Up Number"
          type="text"
          value={formData?.nyscCallUpNumber}
          onChange={(e) => onChange('nyscCallUpNumber', e?.target?.value)}
          error={errors?.nyscCallUpNumber}
          required
          placeholder="e.g., NYSC/FCT/2024/123456"
          description="Your unique NYSC identification number"
        />

        <Select
          label="Service Batch"
          options={batchOptions}
          value={formData?.serviceBatch}
          onChange={(value) => onChange('serviceBatch', value)}
          error={errors?.serviceBatch}
          required
          placeholder="Select batch"
        />

        <Select
          label="State of Deployment"
          options={stateOfDeploymentOptions}
          value={formData?.stateOfDeployment}
          onChange={(value) => onChange('stateOfDeployment', value)}
          error={errors?.stateOfDeployment}
          required
          searchable
          placeholder="Select state"
        />

        <Input
          label="Local Government Area"
          type="text"
          value={formData?.lga}
          onChange={(e) => onChange('lga', e?.target?.value)}
          error={errors?.lga}
          required
          placeholder="Enter LGA of deployment"
        />

        <Input
          label="Date of Commencement"
          type="date"
          value={formData?.commencementDate}
          onChange={(e) => onChange('commencementDate', e?.target?.value)}
          error={errors?.commencementDate}
          required
          description="Format: DD/MM/YYYY"
        />

        <Input
          label="Expected Completion Date"
          type="date"
          value={formData?.completionDate}
          onChange={(e) => onChange('completionDate', e?.target?.value)}
          error={errors?.completionDate}
          required
          description="Format: DD/MM/YYYY"
        />
      </div>
      <div className="border-t border-gray-200 pt-6">
        <h4 className="text-md font-semibold text-gray-900 mb-4">Place of Primary Assignment (PPA)</h4>
        <div className="grid grid-cols-1 gap-6">
          <Input
            label="PPA Name"
            type="text"
            value={formData?.ppaName}
            onChange={(e) => onChange('ppaName', e?.target?.value)}
            error={errors?.ppaName}
            required
            placeholder="Enter your Place of Primary Assignment"
          />

          <Input
            label="PPA Address"
            type="text"
            value={formData?.ppaAddress}
            onChange={(e) => onChange('ppaAddress', e?.target?.value)}
            error={errors?.ppaAddress}
            required
            placeholder="Enter PPA full address"
          />

          <Input
            label="PPA Contact Person"
            type="text"
            value={formData?.ppaContactPerson}
            onChange={(e) => onChange('ppaContactPerson', e?.target?.value)}
            placeholder="Name of contact person at PPA (optional)"
          />
        </div>
      </div>
    </div>
  );
};

export default NYSCInfoStep;